import { Config } from './EnvironmentConstants'

export const ASSETS_BASE_URL = Config.ASSETS_BASE_URL

export const SELF_SERVE_CUSTOM_OBJECT_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/self-serve-custom-object`

export const SELF_SERVE_INTEGRATIONS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/self-serve-integrations`

export const PIPELINE_ITEM_SCHEDULING_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/pipeline-item-scheduling`

export const MOBILE_VIEW_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/mobile-view`

export const FORMS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/forms`

export const COMMON_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/common`

export const CUSTOMER_PORTAL_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/customer-portal`

export const ANALYTICS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/analytics`

export const AUTOMATION_WORKFLOWS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/automation-workflows`

export const BOARDS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/boards`

export const CALLS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/calls`

export const CRM_ITEM_DETAILED_VIEW_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/crm-item-detailed-view`

export const VIEWS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/views`

export const TABLE_VIEW_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/table-view`

export const SIDEBAR_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/sidebar`

export const LEAD_DISTRIBUTION_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/lead-distribution`

export const NAVBAR_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/navbar`

export const NOTIFICATIONS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/notifications`

export const OPERATION_HUB_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/operation-hub`

export const PARAMETER_STORE_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/parameter-store`

export const PIPELINE_EVENTS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/pipeline-events`

export const DESIGN_SYSTEM_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/design-system`

export const SCORING_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/scoring`

export const DATA_LOADING_REFERENCE_SHEETS_BASE_URL_PREFIX = `${ASSETS_BASE_URL}/data-loading-reference-sheets`

export const BPS_OFFICER_ASSETS_URL = `${ASSETS_BASE_URL}/bps-officer-app`
